<template>
    <div class="height-100">
        <gofix-card title=" " class="fixHeight">
            <template slot="gofixCard:right_header">
                <template v-if="!IsReadOnly">
                    <button
                        v-if="$checkRole(this.$accessModule.order_tabs.main_info, 'update')"
                        class="icon-button" @click="open = true"><img width="20" src="img/iconPencil.png" alt="" /></button>
                </template>
            </template>
            <gofix-text-field class="mb-3" classLabel="text-bold color-212121 min-width-150" label="Team FM" oneline>
                <div v-if="Item.fm_team">
                    <span>{{Item.fm_team.group_name}}</span>
                </div>
            </gofix-text-field>
            <gofix-text-field class="mb-3" classLabel="text-bold color-212121 min-width-150" label="FM Officer In Charge" oneline>
                <div v-if="Item.fm_officer">
                    <span class="pr-3">{{Item.fm_officer.name}}</span>
                    <span class="pr-3">{{Item.fm_officer.address && Item.fm_officer.address[0] ? "+" + Item.fm_officer.address[0].primary_phone : null}}</span>
                    <span> {{Item.fm_officer.email}}</span>
                </div>
            </gofix-text-field>
        </gofix-card>
        <b-modal 
            :no-close-on-backdrop="true"
            id="modal-FMOfficer"
            title="FM Officer"
            hide-footer
            :centered="true"
            ref="modal-FMOfficer"
            v-model="open"
            @shown="shownModal">
            <b-form class="formV2" v-bind:class="{'run-loading':loading}">
                <gofix-form-dropdown 
                    label="FM Team" vLabel="group_name"
                    :options="teams" :reduce="option => option.id"
                    :append-to-body="true"
                    v-model="data.team_in_charge_id">
                </gofix-form-dropdown>
                <gofix-form-dropdown
                    label="FM Officer In Charge"
                    vLabel="user_name"
                    @search="searchUsersFM"
                    v-model="data.fm_officer"
                    :options="users">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveData" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'order-fm-officer',
        components: {},
        data () {
            return {
                open: false,
                loading:false,
                data:{
                    fm_officer : null,
                    team_in_charge_id : null,
                },
                users:[],
                timer: null,
                teams:[]
            }
        },
        watch: {
            "Item.contract_id" : function (val) {
                this.loadFMTeam();
            },
        },
        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
        },
        created() {
            if(this.Item) {
                this.loadFMTeam();
            }
        },
        methods: {
            /*--- Get data -----------------------------------------------------------------*/
            async saveData(){
                if(this.loading) return;
                this.loadings = true;
                let data = {
                    officer_in_charge_id : this.data.fm_officer ? this.data.fm_officer.user_id : null,
                    team_in_charge_id : this.data.team_in_charge_id || null,
                    log:'fm_officer'
                };
                this.$store.dispatch("OrderController/updateItem",{ id:this.Item.id, data: data })
                    .then(response => {
                        this.open = false;
                        this.loading = false;
                        this.$alertNotification(this.$notificationV2('editing', 'fm_officer'));
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
            },

            /*--- Get data -----------------------------------------------------------------*/
            loadUser(contract_id,property_id,search){
                this.$store.dispatch("v2UserController/getAccessFmUsers", {
                    contract_id: contract_id,
                    property_id: property_id,
                    section_name: ["Work Order"],
                    module_name : ["All Order"],
                    group_user: true,
                    filter: {name: search}
                }).then(response => {
                    this.users = response.items;
                })
                .catch(err=>{
                    console.log(err)
                })
            },
            searchUsersFM(search, loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.loadUser(this.Item.contract_id,this.Item.service_location,search)
                    loading(false);
                }, 500);
            },
            loadFMTeam() {
                this.teams = []
                if (!this.Item.contract_id) {
                    return;
                }
                this.$store.dispatch("UserGroupController/getItems", {
                    page: 1,
                    limit: -1,
                    filter: {
                        contract_id: this.Item.contract_id
                    }
                }).then(response => {
                    this.teams = response.items;
                })
                .catch(err => {
                    this.teams = [];
                })
            },
            /*--- Shown Modals -----------------------------------------------------------------*/
            shownModal(){
                this.data.fm_officer = this.Item.fm_officer ? {
                    user_id: this.Item.fm_officer.id,
                    user_email: this.Item.fm_officer.email,
                    user_name: this.Item.fm_officer.name,
                    user_phone: this.Item.fm_officer.address_data ? this.Item.fm_officer.address_data.primary_phone:null,
                } : null;
                this.data.team_in_charge_id = this.Item ? this.Item.team_in_charge_id : null;
                this.loadUser(this.Item.contract_id ,this.Item.service_location,null)
            }
        }
    }
</script>